import React, { createContext } from 'react';

import { EasyClaimDocumentService } from '../easyclaim.app.services';

const DocumentServiceContext = createContext<EasyClaimDocumentService | undefined>(undefined);

export const DocumentServiceProvider: React.FC<{
	documentService: EasyClaimDocumentService | undefined;
	children: React.ReactNode;
}> = ({ documentService, children }) => (
	<DocumentServiceContext.Provider value={documentService}>
		{children}
	</DocumentServiceContext.Provider>
);

export default DocumentServiceContext;
